import styled from '@emotion/styled'
import { wrap as withStyle, themeColor } from 'utils/styles'
import CardList from 'components/CardList'
import { Icon } from 'components/patterns'

export default withStyle(
  () => `
    width: 1200px !important;

    .ant-modal-body {
      padding: 0px !important;
    }
  `
)

export const ModalHeader = styled.div`
  padding-bottom: 8px;
  border-bottom: 1px solid ${themeColor('modalBorderColor')};
  display: flex;
  font-size: medium;
  flex-direction: column;
  vertical-align: middle;
`

export const StyledIcon = styled(Icon)`
  margin-top: 4px;
  margin-left: 8px;
`

export const StyledSpan = styled.span`
  font-size: 12px;
  margin-top: 4px;
  margin-left: 4px;
`

export const ModalBanner = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 25px;
  border-radius: 4px 4px 0px 0px;
  background-color: ${themeColor('alertWarningBgColor')};
`

export const ModalMainContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const ModalContent = styled.div`
  display: flex;
  flex-direction: row;
  padding: 1px 25px 35px;
  border-bottom: thin solid ${themeColor('grey')};
`

export const StyledCardContent = styled.span`
  font-size: 12px;
  font-weight: bold;
  color: ${themeColor('ctpModalCardTextColor')};
  width: 14px;
  height: 14px;
`

export const GroupMeta = styled.div`
  font-size: 18px !important;
  font-weight: 700 !important;
  display: flex;
  flex-direction: row;
  vertical-align: middle;
  padding: 8px 0 0 0;
  margin-left: 10px;
  > div {
    height: 24px;
  }
`

export const SideMenu = styled(CardList)`
  width: 225px;

  > div {
    height: 94px;

    > div:first-of-type {
      height: 94px;
    }
  }
`
